// Basis-SEO-Templates für statische Routen
// Placeholder {CITY} wird bei Standortseiten ersetzt
export const routeDescriptions = {
  Startseite: 'Essen online bestellen – Pizza, Burger, Döner, Sushi & mehr. Schnelle Onlinezahlung (PayPal, Apple Pay, Google Pay) und Statusupdates. Gutes essen – Gutes tun!',
  Pizza: 'Pizza online bestellen – Lieblingspizzas frisch gebacken. Verschiedene Größen & Beläge, sichere Onlinezahlung.',
  Burger: 'Burger bestellen – Frische Burger, knusprige Pommes & mehr direkt zu dir nach Hause.',
  Doener: 'Döner & türkische Spezialitäten bestellen – Frisch, lecker und schnell geliefert.',
  Lieferorte: 'Alle Lieferorte und Gemeinden im Westerwald & Umgebung. Finde deinen Lieferdienst für Pizza, Burger, Döner & mehr.',
  Lieferdienstauswahl: 'Lieferdienste in {CITY} vergleichen – Pizza, Burger, Döner, asiatisch & mehr jetzt bestellen.',
  Anbieter: 'Lieferdienste in {CITY} – Jetzt Essen bestellen bei Anbietern für Pizza, Pasta, Burger, Döner & mehr.',
  Speisekarte: 'Speisekarte ansehen & bequem online bestellen – sichere Zahlung & Statusupdates.',
  Warenkorb: 'Bestellung prüfen & sicher online bezahlen – PayPal, Apple Pay, Google Pay oder Barzahlung.',
  Bewertungen: 'Echte Kundenbewertungen lesen – So bewerten Gäste ihren Lieferdienst.',
  Archiv: 'Bestellhistorie – Vergangene Bestellungen einsehen & Lieblingsgerichte erneut bestellen.',
  Registrierung: 'Registrieren und schneller bestellen – Adressen, Favoriten & Gutscheine speichern.',
  Recommend: 'Lieblings-Lieferdienst empfehlen – Wir nehmen neue Restaurants im Westerwald auf.',
  Business: 'Firmenkunden-Angebote – Einfach Sammelbestellungen & digitale Abrechnung.',
  Agb: 'Allgemeine Geschäftsbedingungen für Besteller – Rechtliche Hinweise.',
  AgbBusiness: 'AGB für Anbieter – Teilnahmebedingungen & rechtliche Regelungen.',
  Datenschutz: 'Datenschutzhinweise – So verarbeiten wir deine Daten sicher & transparent.',
  Impressum: 'Impressum & Anbieterkennzeichnung – Verantwortliche Stelle & Kontaktdaten.',
  // Dynamische Kategorie-Stadt Seiten (werden programmatisch verarbeitet):
  PizzaCity: 'Pizza bestellen in {CITY} – Frisch belegt & schnell geliefert. Online bezahlen & Statusupdates.',
  BurgerCity: 'Burger bestellen in {CITY} – Saftige Burger & knusprige Beilagen. Onlinezahlung & schnelle Lieferung.',
  DoenerCity: 'Döner bestellen in {CITY} – Frisch vom Spieß mit knackigem Salat. Jetzt online bestellen.'
}

// Fallback generische Beschreibung
export const fallbackDescription = 'Online Essen bestellen im Westerwald – Pizza, Burger, Döner, asiatisch & mehr. Schnelle Zahlung & Statusupdates.'

// Hilfsfunktion zur City-Aufbereitung
export function humanizeCity (geoUrl = '') {
  if (!geoUrl) return ''
  // Beispiel: montabaur-zentrum -> Montabaur
  const city = geoUrl.split('-')[0]
  if (!city) return ''
  return city.charAt(0).toUpperCase() + city.slice(1)
}



// WEBPACK FOOTER //
// ./src/seo/metadata.js